<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            Items
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Setting Dashboard</el-button>
            </div>
          </div>
          <el-tabs v-model="activeItemsTab" @tab-click="handleClick">
            <!-- <el-tab-pane name="service" label="Service">
              <itemService ref="service" />
            </el-tab-pane>
            <el-tab-pane name="nonInventory" label="Non Inventory">
              <itemNonInventory ref="nonInventory" />
            </el-tab-pane>
            <el-tab-pane name="inventory" label="Inventory">
              <itemInventory ref="inventory" />
            </el-tab-pane>
            <el-tab-pane name="inventoryAssembly" label="Inventory Assembly">
              <itemInventoryAssembly ref="inventoryAssembly" />
            </el-tab-pane>
            <el-tab-pane name="groupedItem" label="Grouped Item">
              <itemGroupedItem ref="groupedItem" />
            </el-tab-pane>
            <el-tab-pane name="digital" label="Digital">
              <itemDigital ref="digital" />
            </el-tab-pane> -->
            <el-tab-pane name="fixedAsset" label="Fixed Asset">
              <itemFixedAsset ref="fixedAsset" />
            </el-tab-pane>
            <el-tab-pane name="rentalAsset" label="Rental Asset">
              <itemRentalAsset ref="rentalAsset" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import settingTable from '@/components/settings/settingTable'
import itemService from '@/components/settings/items/itemService.vue'
import itemNonInventory from '@/components/settings/items/itemNonInventory.vue'
import itemInventory from '@/components/settings/items/itemInventory.vue'
import itemInventoryAssembly from '@/components/settings/items/itemInventoryAssembly.vue'
import itemDigital from '@/components/settings/items/itemDigital.vue'
import itemGroupedItem from '@/components/settings/items/itemGroupedItem.vue'
import itemFixedAsset from '@/components/settings/items/itemFixedAsset.vue'
import itemRentalAsset from '@/components/settings/items/itemRentalAsset.vue'
let moment = require('moment')
import axios from 'axios'
export default {
  name: "Items",
  components: {
    settingTable,
    itemService,
    itemNonInventory,
    itemInventory,
    itemInventoryAssembly,
    itemGroupedItem,
    itemDigital,
    itemFixedAsset,
    itemRentalAsset,
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
  },
  data() {
    return {
      moment: moment,
      activeItemsTab: 'fixedAsset',
    }
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name === 'service') {
        this.$refs['service'].loadList(tab.name)
      } else if (tab.name === 'nonInventory') {
        this.$refs['nonInventory'].loadList(tab.name)
      } else if (tab.name === 'inventory') {
        this.$refs['inventory'].loadList(tab.name)
      } else if (tab.name === 'groupedItem') {
        this.$refs['groupedItem'].loadList(tab.name)
      } else if (tab.name === 'digital') {
        this.$refs['digital'].loadList(tab.name)
      } else if (tab.name === 'fixedAsset') {
        this.$refs['fixedAsset'].loadList(tab.name)
      } else if (tab.name === 'rentalAsset') {
        this.$refs['rentalAsset'].loadList(tab.name)
      }
    },
    loadFirstTab() {
      this.activeItemsTab = 'fixedAsset'
      this.$refs['fixedAsset'].loadList('fixedAsset')
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
  }
}
</script>

<style lang="less" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
